import { formatify } from "./formatify.js";
import { nbsp } from "./unicodes/nbsp.js";
import { wordjoiner } from "./unicodes/wordjoiner.js";

/**
 * Renders the formatify syntax down to plain text (no markup).
 *
 * Use it where formatted markup can't be rendered — e.g. a truncated teaser inside a clickable
 * card (a formatify link would produce an invalid nested `<a>`) or a meta/og description.
 * Reuses {@link formatify} so the supported syntax never drifts out of sync.
 */
export function formatifyToText(input: string | undefined): string {
	return formatify(input)
		.replace(/<[^>]*>/gu, "")
		.replaceAll(nbsp, " ")
		.replaceAll(wordjoiner, "")
		.replaceAll("&lt;", "<")
		.replaceAll("&gt;", ">")
		.replaceAll("&apos;", "'")
		.replaceAll("&quot;", '"')
		.replaceAll("&amp;", "&");
}
